module.exports = __webpack_public_path__ + "assets/images/diabetes_g.2cecf7d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/diabetes_g.png
// module id = 698
// module chunks = 1